import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { createCtx, handleError, callSuccessToast } from '../../../../helpers'
import UsersForm from './UsersForm.vue'
import { CardHeader } from '../../../../components'

import {
  RolesService,
  ControlQuestionsService,
  CardIssuePointsService,
  UsersService,
  MunicipalEntitiesService,
  AppAuthService,
  AddUserOpts,
} from '@prodcard/core'
import { pickBy } from 'lodash'
import { UserOpts } from '../interfaces'


export default /*#__PURE__*/_defineComponent({
  __name: 'UsersNewPage',
  props: {
    usersService: {},
    rolesService: {},
    controlQuestionsService: {},
    cardIssuePointsService: {},
    municipalEntitiesService: {},
    authService: {}
  },
  setup(__props: any) {

const props = __props;



const router = useRouter()

const loading = ref(false)

const createUser = (userOpts: UserOpts) => {
  handleError(async () => {
    await props.usersService.add(createCtx(), pickBy(userOpts, o => o) as AddUserOpts)
    callSuccessToast('Пользователь создан')
    router?.back()
  }, loading)
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "pa-0" }, {
        default: _withCtx(() => [
          _createVNode(_unref(CardHeader), null, {
            title: _withCtx(() => [
              _createTextVNode(" Новый пользователь ")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, { class: "mt-8 pa-0" }, {
        default: _withCtx(() => [
          _createVNode(UsersForm, {
            "roles-service": _ctx.rolesService,
            "card-issue-points-service": _ctx.cardIssuePointsService,
            "control-questions-service": _ctx.controlQuestionsService,
            "municipal-entities-service": _ctx.municipalEntitiesService,
            "auth-service": _ctx.authService,
            loading: loading.value,
            onSubmit: createUser
          }, null, 8, ["roles-service", "card-issue-points-service", "control-questions-service", "municipal-entities-service", "auth-service", "loading"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})